import apiClient from './index';
import { NotificationOutboxRead } from './types';

export const notificationOutboxApi = {
  async list(params: {
    building_id: string;
    schedule_id?: string;
    status?: string;
    limit?: number;
    offset?: number;
  }): Promise<NotificationOutboxRead[]> {
    const res = await apiClient.get<NotificationOutboxRead[]>('/notification-outbox/', { params });
    return res.data;
  },
};
